import { AxiosResponse } from 'axios';

export const getFilenameFromResponseHeader = (
  response: AxiosResponse<File>,
): string => {
  // See https://datatracker.ietf.org/doc/html/rfc5987
  const headerContent: string = response.headers['content-disposition'];
  // parmname "*" LWSP "=" LWSP ext-value
  const params = headerContent.split(';').map(paramString =>
    paramString
      .trim()
      .split('=', 2)
      .map(paramComponentString => paramComponentString.trim()),
  );
  const regularFilenameParameter = params.find(
    ([paramName]) => paramName === 'filename',
  );
  const extendedFilenameParameter = params.find(
    ([paramName]) => paramName === 'filename*',
  );
  if (extendedFilenameParameter) {
    const value = extendedFilenameParameter[1];
    // charset  "'" [ language ] "'" value-chars
    const [, , , filename] = /([^']+)'(.*?)'(.*)/.exec(value) || [];
    return decodeURIComponent(filename);
  }
  // make unquoted if quoted
  const filenameValue = regularFilenameParameter?.[1];
  if (filenameValue) {
    if (
      filenameValue[0] === '"' &&
      filenameValue[filenameValue.length - 1] === '"'
    ) {
      return filenameValue.slice(1, filenameValue.length - 1);
    }
    return filenameValue;
  }
  return '';
};
